const cancel = 'Annuller'
const save = 'Gem'

export default {

  global: {
    generalError: 'Ej, ærgerligt! Anmodningen kunne desværre ikke gennemføres. Download venligst side igen.',
    signature: 'Med venlig hilsen,',
  },

  component: {
    actionBar: {
      actions: 'Handlinger',
      hideActions: 'Skjul handlinger',
    },

    addButton: {
      add: 'Tilføj',
    },

    attachments: {
      add: 'Tilføj CV eller andre vedhæftede filer',
      placeholderWithDescription: 'Tilføj de vedhæftede filer, der anmodes om',
      remove: 'Fjern',
      allowedFileTypes: 'Tilladte filtyper',
      errors: {
        size: 'File er for stor. Filen må højst være 5MB.',
        empty: 'Filen indeholder ingen data',
        invalidType: fileType => `Beklager, af sikkerhedsmæssige årsager er ${fileType}-filer ikke tilladt`,
        typeNotWhitelisted: 'Beklager, filtypen er ikke tilladt.',
      },
    },

    agreeTos: {
      privacyLinkText: 'Privatlivspolitik',
      termsLinkText: 'Vilkår og betingelser',
      privacyPolicyText: 'Vi værdsætter dit privatliv, læs venligst vores ',
      termsText1: 'Læs og accepter ',
      termsText2: 'før du giver os dine personlige oplysninger.',
      privacyLink: 'https://new.recright.com/privacy-policy',
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `Hvis du ikke ønsker, at vi skal håndtere dine personlige data, kan du sende en besked til ${mail} og bede om at få dem fjernet.`,
      customSupportPrivacyInfo: link => `Hvis du ikke ønsker, at vi behandler dine personlige data, kan du bede om at få dem fjernet ved at kontakte ${link}.`,
    },

    buttons: {
      close: 'Stäng',
    },

    competencies: {
      addCompetency: 'Tilføj en ny kompetence',
      edit: 'Redigér kompetencer',
      done: 'Udført',
      defaultsDescription: 'Hvis du er i tvivl om, hvilke kompetencer du vil bruge, har vi defineret nogle gode standardværdier til at begynde med.',
      getDefaults: 'Hent standardværdierne',
    },

    competency: {
      warning: 'Fjern kompetence og alle dens vurderinger?',
    },

    confirmDelete: {
      delete: 'Slet',
      cancel: 'Annullering',
      confirm: 'Bekræfte',
    },

    confirm: {
      cancel: 'Slet optagelse',
      confirm: 'Prøv igen',
    },

    confirmButton: {
      wait: count => `Vent ${count}`,
      confirm: 'Bekræft',
    },

    controlStatus: {
      text: {
        empty: 'Udfyld',
        valid: () => 'Klar',
      },
      textarea: {
        empty: 'Udfyld',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'Indstil',
        valid: () => 'Klar',
      },
      file: {
        empty: 'Vælg',
        valid: () => 'Ændr',
      },
      list: {
        empty: 'Tilføj',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: 'Søg',
        valid: () => 'Klar',
      },
    },

    cookieConsentModal: {
      title: 'Vores websted bruger cookies',
      body: 'Ved at acceptere alle cookies accepterer du, at der gemmes cookies på din enhed for at forbedre webstedsnavigationen, analysere brugen af webstedet og hjælpe os i vores markedsføring.',
      learnMoreLinkText: 'Læs mere om, hvordan vi bruger cookies',
      learnMoreLink: 'https://new.recright.com/cookies/', // TODO add localized links when the page is translated
      manageCookies: 'Administrer cookies',
      acceptAll: 'Accepter alle cookies',
      manageTitle: 'Administrer præferencer for samtykke',
      necessaryCookiesTitle: 'Nødvendige cookies',
      necessaryCookiesBody:
        'Disse cookies er nødvendige for, at webstedet kan fungere, og de kan ikke slås fra i vores systemer.',
      performanceCookiesTitle: 'Performance-cookies',
      performanceCookiesBody:
        'Disse cookies giver os mulighed for at tælle antallet af besøg og trafikkilderne, så vi lettere kan måle og øge antallet af besøgende på vores websted.',
      confirmChoices: 'Bekræft mine valg',
      marketingCookiesTitle: 'Cookies til markedsføring',
      marketingCookiesBody:
        'Disse cookies giver os mulighed for at tilpasse annoncer og måle annoncers effektivitet.',
      functionalCookiesTitle: 'Funkční soubory cookie',
      functionalCookiesBody:
        'Tyto soubory cookie se používají k vylepšení funkčnosti webových stránek. Některé funkce nemusí být bez těchto souborů cookie dostupné. K příkladům využití funkčních cookies patří služby webového chatu a uživatelská nastavení.',
    },

    emailAddresses: {
      remove: 'Fjern',
      importCsv: 'Import CSV',
      invalidEmails: 'Ugyldige e-mailadresser fundet.',
      maxCsvEntryErrorNotification: amount =>
        `Maks. ${amount} csv-poster er tilladt.`,
      importCsvTooltip:
        'CSV-rækkerne kan enten indeholde kun en e-mailadresse eller både en e-mailadresse og et telefonnummer. Hver række repræsenterer en modtager. Telefonnumre skal være i internationalt format (E.164), f.eks. <strong>+358</strong>50xxxxxxx.',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'E-mail blev afvist. Kontroller, om modtageren har modtaget din meddelelse.',
      },
      Permanent: {
        General: 'E-mail kunne ikke leveres. Modtagerens e-mailudbyder afviste meddelelsen.',
        NoEmail: 'E-mailadressen findes ikke.',
        Suppressed: 'E-mail blev ikke leveret på grund af tidligere mislykkede leveringsforsøg.',
      },
      Transient: {
        General: 'E-mail blev afvist. Kontroller, om modtageren har modtaget din meddelelse.',
        MailboxFull: 'Modtagerens indbakke er fuld.',
        MessageTooLarge: 'Meddelelsens indhold er for stort.',
        ContentRejected: 'Meddelelsens indhold afvist.',
        AttachmentRejected: 'Vedhæftet fil afvist.',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS message added to message queue, waiting for delivery.',
      failed: 'Sending SMS message failed.',
      duplicate: 'Nummeret er allerede tilknyttet en kandidat i jobsamtalen.',
    },

    error403: {
      heading: 'Adgang forbudt',
      content: 'Kontroller, at du er logget ind på den rigtige konto og er blevet inviteret til at se denne stillingsopslag i Recright. Kontroller også, at du bruger Recright med et enkelt browservindue på samme tid.',
      link: 'Forside',
    },

    error404: {
      heading: 'Ingenting der',
      content: 'Vi har kigget rigtig godt efter, men der er ingen hjemmeside med den adresse, du har indtastet. Er du kommet til at klikke på et gammelt, dødt link, eller er du kommet til at taste forkert?',
      link: 'Forside',
    },

    error410: {
      heading: 'Lukket',
      content: 'Job kan ikke vises, fordi det enten er lukket eller ansøgningsperioden er slut.',
      link: 'Forside',
    },

    calendarError: {
      heading: 'Connecting calendar failed',
      content: 'We were unable to connect your calendar. Please try again later and if the issue continues please contact our support.',
    },

    footer: {
      terms: 'Brugervilkårene og betingelserne for Recright',
      license: 'Recrights generelle tjenestevilkår',
      privacyPolicy: 'Privatlivspolitik',
      customSupport: link => `Kontakt ${link}`,
      accessibilityReport: 'Accessibility report',
    },

    feedbackPulse: {
      howWouldYouRateInterview: 'Hvordan vil du bedømme din interviewoplevelse?',
      howWouldYouRateJobAd: 'Hvordan vil du vurdere din ansøgningsoplevelse?',
      yourResponseIsAnonymous: 'Dit svar er anonymt.',
      thankYouFeedback: 'Tak for din feedback!',
    },

    candidateFooter: {
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://new.recright.com/privacy-policy',
      accessibilityReportLink: 'https://new.recright.com/hubfs/RecRight_Accessibility_report.pdf',
    },

    formErrors: {
      typeNotWhitelisted: 'Beklager, filtypen er ikke tilladt.',
      isRequired: 'Dette felt skal udfyldes.',
      isEmail: value => `${value} er ikke en gyldig e-mailadresse.`,
      isDate: value => `${value} er ikke en gyldig dato.`,
      invalidUrl: 'URL er ugyldigt.',
      singleHireEndError: 'Man kan ikke bruge single hire i mere end 60 dage.',
      isNotTooOldForLive: 'Den indtastede dato skal være efter dags dato.',
      isNotAfterEndDate: 'Den valgte dato kan ikke være efter datoen, hvor jobannoncen lukkes.',
      isValidMobilePhone: value => `${value ? `${value} is not` : 'Not'} a valid mobile phone number.`,
      isInternationalPhoneNumber: 'Phone number must be in international format.',
      duplicateNumber: 'Telefonnummeret er allerede tilføjet.',
      duplicateCompetency: 'Der findes allerede en kompetence med det navn',
      isNotDuplicateTemplateName:
        'Der findes allerede en e-mailskabelon med dette navn.',
    },

    jobAdApplication: {
      name: 'Navn',
      email: 'E-mail',
      phone: 'Telefonnummer',
      city: 'By',
      applyForPosition: 'Ansøg om stilling',
      back: 'Tilbage',
      continue: 'Fortsæt',
      submit: 'Indsend',
      saveForLater: 'Forsæt senere',
      namePlaceholder: 'Indtast dit navn',
      emailPlaceholder: 'Indtast din e-mail-adresse',
      phonePlaceholder: 'Indtast dit telefonnummer',
      cityPlaceholder: 'Indtast din nuværende hjemby',
      links: 'Du kan indtaste link',
      legendAdditionalFields: 'Yderligere oplysninger',
      legendBasicInfo: 'Grundlæggende oplysninger',
      legendLinks: 'Link',
      legendAttachments: 'Vedhæftede filer',
      coverLetter: 'Følgeskrivelse',
      attachments: 'Vedhæftede filer',
      introduction: 'Skriv din introduktion her',
      thankYou: 'Mange tak.',
      luck: 'Held og lykke!',
      close: 'Luk',
      required: '* Felterne mærket med en stjerne er obligatoriske.',
    },

    jobAdContainer: {
      endTime: date => (date ? `åben indtil ${date}` : ''),
    },

    jobAdDetails: {
      apply: 'Ansøg om job',
    },

    jobAdRow: {
      responses: 'Ansøgninger',
      status: {
        open: 'Åben',
        filled: 'Udfyldt',
        cancelled: 'Annulleret',
        done: 'Udført',
        close: 'Luk',
        draft: 'Lukket (kladde)',
        hidden: 'Skjult',
      },
    },

    jobAdQuickInterview: {
      back: 'Tilbage',
      submit: 'Indsend',
      saveForLater: 'Forsæt senere',
      title: 'Lynvideojobsamtale',
      description: 'Med henblik på at lære dig hurtigere at kende vil vi gerne bede dig besvare vores lynjobsamtalespørgsmål kortfattet. Få din personlighed med, og giv din ansøgning sjæl.',
      requiredNote: 'Bemærk, at det er en del af ansøgningsprocessen, og at rekrutteringsagenten først modtager din ansøgning, når du har registreret dit svar.',
      reminderNote: 'Du kan optage svaret med det samme, eller du kan fortsætte på et senere tidspunkt ved at modtage en påmindelse via e-mail.',
    },

    interviewRow: {
      responses: 'Kandidater',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'Vis LinkedIn-profil',
    },

    linkedInButton: {
      error: 'Fejl under hentning af profil. Prøv igen.',
      buttonText: 'Søg via LinkedIn',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'Du kan forudfylde ansøgningsformularen ved hjælp af din LinkedIn-profil',
      linkedInOr: 'Eller',
      error: 'Fejl under hentning af profil. Prøv igen.',
    },

    linkListInput: {
      addField: 'Tilføj',
      removeField: 'Fjern',
      invalidUrl: 'URL er ugyldigt.',
    },

    loadingButton: {
      loading: 'Loading...',
      saving: 'Gemmes...',
      sending: 'Afsendelse...',
    },

    modalApplicationForm: {
      applyForPosition: 'Ansøg stillingen',
      continue: 'Fortsæt',
      name: 'Skriv dit navn',
      email: 'Skriv din email-addresse',
      phoneNumber: 'Skriv dit telefonnummer',
      links: 'Indsæt eventuelt links her',
      legendLinks: 'Links',
      legendAttachments: 'Vedhæftede filer',
      coverLetter: 'Følgebrev',
      attachments: 'Vedhæftede filer',
      introduction: 'Skriv din præsentation her',
      thankYou: 'Tak.',
      luck: 'Held og lykke!',
      close: 'Luk',
    },

    modalConfirm: {
      cancel,
      confirm: 'OK',
    },

    modalAlert: {
      close: 'Close',
    },

    modalLinkShare: {
      title: 'Delbart offentligt link',
      info: 'Her er et link til jobannoncen, som du kan dele. Alle interesserede kan se annoncen og søge den. Du får en notifikation, når der kommer ansøgninger, præcis som du plejer. Her er et offentligt link til annoncen:',
    },

    modalVideoAdd: {
      title: 'Tilføj en ny video',
      chooseTitle: 'Tilføj en ny video',
      titlePlaceholder: 'Skriv overskriften på video her',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: 'Uploade en ny video',
      info: 'Max tilladte video størrelse er 500mb. Vi anbefaler, at videoerne er komprimeret før upload, på denne måde uploade og konvertering vil tage mindre tid.',
    },

    modalCandidateInfo: [
      {
        headline: 'Du kan tage din video om, ',
        content: 'så mange gange du vil og først sende den, når du er helt tilfreds. Svarene gemmes umiddelbart efter optagelsen, og du kan vende tilbage til interviewet til enhver tid via linket sendt til din email.',
        mobileContent: 'så mange gange du vil og først sende den, når du er helt tilfreds. Tilføj videoen til interviewet. Du vil se, at videoen bliver uploadet og gemt i interviewet. Du kan vende tilbage til videointerviewet via det link, du har modtaget per e-mail. <br><br><strong>Hvis din skærm stadig er sort, og du anvender en Apple-mobilenhed, kan du finde instrukser til løsning af problemet <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">her</a>.</strong>',
      },
      {
        headline: 'Check umiddelbart efter optagelsen, ',
        content: 'at din stemme kan høres uden problemer, og at videoen afspilles normalt. Når du trykker på knappen "send svar", vil videoen blive låst. Det er derfor ikke muligt at ændre dit svar efter det.',
      },
      {
        headline: 'Når du har optaget alle svarene ',
        content: 'og interviewet er færdigt, tryk på "Send svar og fuldfør interviewet." Du kan ikke revidere dit svar efter tryk på denne knap. Hvis du vil fortsætte senere, skal du trykke på "Fortsæt senere".',
      },
      {
        headline: 'Hvis du har brug for hjælp ',
        content: mailto => `t besvare de spørgsmål, kan du kontakte os via "Hjælp" knappen nederst til højre på siden. Du kan også kontakte os via e-mail til adressen ${mailto}.`,
        customContent: link => `Kontakt ${link}`,
      },
    ],

    navigationBar: {
      back: 'Tilbage',
      dashboard: 'Hovedvisning',
      frontpage: 'Forside',
    },

    personDetails: {
      stage: 'Niveau',
      namePlaceholder: 'Kandidat',
      contact: 'Kontakt',
      links: 'Link',
      attachments: 'Vedhæftninger',
      coverLetter: 'Følgeskrivelse',
      referrer: 'Oprindelse',
      referrerInfo: 'Websitet, som kandidaten kom fra til tjenesten.',
      noStage: 'Ikke på noget niveau endnu',
      headerAdditionalInformation: 'Yderligere oplysninger',
      lastSeen: time => `Sidst set ${time}.`,
      state: {
        invited: 'Inviteret',
        visited: 'Besøgt',
        incomplete: 'Ufuldstændig',
        completed: 'Gennemført',
      },
      notVisited: 'Har ikke besøgt på interview.',
      scheduledInterview: 'Scheduled interview',
      scheduledInterviewInvitationSent: 'Invited to a meeting',
      scheduledInterviewInvitationExpired: 'Invitation has expired',
      scheduledInterviewInvitationEventCreated: 'Meeting:',
      scheduledInterviewReScheduleMeeting: 'Reschedule meeting',
      otherPersons: count => `Også fundet i ${count} andre stillinger`,
    },

    phoneInput: {
      placeholder: example => `Telefonnummer i formatet ${example}`,
    },

    rating: {
      ownVote: 'Din bedømmelse',
      yourVotePlaceholder: 'Du har ikke stemt endnu.',
      yourRating: rating => `Din bedømmelse: ${rating}`,
      totalVotes: count => `'I alt ${count} vurderinger`,
      mobileModalHeader: 'Tilføj din vurdering',
      noRatings: 'Ingen vurderinger endnu',
      yourRatingReset: 'Nulstil din stemme',
      averageRating: 'Gennemsnitlig vurdering',
      reset: 'nulstil',
    },

    questionsAndResponses: {
      response: 'Svar',
      noResponse: 'Intet svar',
      resetQuestionResponse: 'Slet kandidatsvar',
      resetQuestionResponseConfirm: questionTitle =>
        `Er du sikker på, at du vil nulstille spørgsmålet "${questionTitle}" til kandidaten og slette deres svar?`,
      resetQuestionResponseConfirm2:
        'Hvis du gør det, kan kandidaten besvare spørgsmålet på ny',
    },

    share: {
      share: 'Del med',
      copy: 'Kopier link',
    },

    sort: {
      sort: 'Sorter',
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: 'valgt',
      change: 'Ændr',
    },

    video: {
      videoNotFound: 'Video er under behandling eller video er ikke fundet',
      retry: 'Prøv igen',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? 'Tilføj en ny video' : 'Vælg fil'),
      videoPlaceholder: 'Optag dit svar',
      uploadPlaceholderCandidate: 'Upload dit svar',
      submit: 'Indsend svar',
      notAnswered: 'Endnu ikke besvaret',
      remove: 'Slet optagelse',
      converting: 'Video er ved at blive konvertered. Vent venligst...',
      uploading: 'Video bliver uploadet. Vent venligst...',
      error: {
        invalid: 'Den valgte fil er for stor. Vælg en anden fil.',
        upload: 'Vi kunne ikke uploade videoen, undskyldninger. Prøv igen.',
        transcode: 'Den valgte videofilen var beskadiget eller ikke gyldig, prøv igen.',
      },
    },

    virtualBg: {
      showMoreButtonText: 'Vis flere',
      showLessButtonText: 'Vis færre',
      infoText1:
        'Hold fanen aktiv i forgrunden under optagelse. Brug ikke andre applikationer under optagelse.',
      infoText2:
        'Baggrundsvideoer fungerer bedst i de nyeste browsere og med en enhed, der er relativt ny og kraftfuld.',
      infoText3:
        'Sørg for, at der ikke er andre applikationer, som bruger mikrofonen eller kameraet.',
    },

    webcam: {
      useVideoBgButtonText: 'Brug videobaggrund',
      removeVideoBgButtonText: 'Fjern videobaggrund',
      starting: 'Starter ...',
      close: 'Luk kamera',
      remove: 'Slet optagelse',
      record: 'Optag',
      stop: 'Stop',
      retake: 'Optag igen',
      submit: 'Indsend svar',
      processing: 'Behandler ...',
      converting: 'Video er ved at blive konvertered. Vent venligst...',
      uploading: 'Video bliver uploadet. Vent venligst...',
      downloading: 'Video bliver downloadet. Vent venligst...',
      uploadInProgress: 'Videooverførsel er i gang. Du må ikke lukke browseren eller skifte side.',
      uploaded: 'Video overført.',
      error: {
        DevicesNotFoundError: 'Unable to use camera or microphone. Please check they are enabled.',
        NotFoundError: 'Unable to use camera or microphone. Please check they are enabled.',
        NotAllowedError: 'You didn\'t give a permission to use the camera or microphone.',
        PermissionDismissedError: 'You dismissed permission dialog. Please give permission to use the camera and microphone.',
        PermissionDeniedError: 'You have denied camera or microphone access.',
        NotReadableError: 'Can\'t read camera or microphone stream. Possible hardware issue.',
        SecurityError: 'Can\'t use camera or microphone because of security error',
        stream: 'Der er sket en fejl. Genstart din browser.',
        download: 'Det lykkedes ikke at downloade videoen. Prøv igen?',
        upload: ' Det lykkedes ikke at uploade videoen. Prøv igen?',
        emptyBlob: 'Din browser- eller computerhukommelse er fuld, og den kan ikke danne optagelsen. Opdater siden, og hvis det ikke hjælper, bør browseren genstartes.',
        alternativeRecorder: 'Du kan også uploade filer ved at klikke her.',
        reconnecting: 'Forbindelsen blev afbrudt. Prøv at oprette forbindelse igen.',
      },
    },

    videoResponse: {
      videoPlaceholder: 'Optag dit svar',
      uploadPlaceholder: 'Upload dit svar',
      submit: 'Indsend svar',
      notAnswered: 'Endnu ikke besvaret',
      startInterview: 'Start jobsamtale ',
    },

    flash: {
      starting: 'Initialiserer ...',
      connection_error_hint: 'Der kunne ikke oprettes forbindelse til netværket. Prøv at indlæse siden en gang til.',
      permission_hint: 'Du skal give siden adgang til dit webcam og mikrofonen.',
      searching_camera_hint: 'Prøver at finde et webcam ...',
      camera_reserved_hint: 'Dit webcam bruges af et andet program eller en anden hjemmeside. Luk programmet/siden og genindlæs denne side.',
      camera_reserved_hint_chrome_extra: 'Kære Chrome-bruger, du skal give Recright adgang til at bruge dit Webcam fra dialogen under adresselinjen.',
      no_camera_hint: 'Webcam kan ikke findes.',
      no_mic_hint: 'Mikrofon kan ikke findes.',
      uploading_text: 'Uploader ...',
      rtmpt_in_use: 'Dette trin er ikke nødvendigt, hvis dit netværk/administrator tillader RTMP. Spørg os hvordan.',
      preview_text: 'Dit webcam er indstillet til preview',
      close_text: 'Luk kamera',
      remove_text: 'Slet optagelse',
      noflash_errortext_install: link => `Det ser ud til, at du ikke har Adobe Flash Player. Du skal bruge et flash plugin til at optage videoer. Få flash her: ${link}`,
      noflash_errortext_enable: link => `Hvis du allerede har installeret flash, men stadig ser denne meddelelse. Se her: ${link}`,
      noflash_errortext_differentbrowser: 'Alternativt kan du prøve med en browser, som understøtter HTML5-optagelse. Vi foreslår Chrome eller Firefox.',
    },

    smsMessages: {
      invitationMessage: title =>
        `Hej! Vi vil gerne invitere dig til en video-jobsamtale ${title}! Denne invitation blev også sendt til din e-mailadresse. `,
    },
  },
  page: {
    interviewPreview: {
      info: 'Dette er en forhåndsvisning af jobsamtalen. Videooptagelse er deaktiveret, og formulardata gemmes ikke.',
    },
  },
}
